import type { Question } from "@quizzes/_schema";

/**
 * True when a question opts into per-session option randomization. Only
 * single/multi questions carry the flag; every other type is always false.
 * Read-only: the admin uses this to display a badge, never to set the flag.
 */
export function isRandomizedQuestion(q: Question): boolean {
  return (q.type === "single" || q.type === "multi") && q.randomizeOptions === true;
}
